<div class="highlights">
    <div class="highlights-container bg-gray-500" [ngClass]="{'is-locked': isLocationScreensGreyedOut}">
        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold"
                [ngClass]="isLocationScreensGreyedOut ? 'text-gray-light' : 'text-gray-light'">Locations</span>
            <img src="./assets/images/icons/highlights/placeholder.svg"
                [ngClass]="{'text-gray-light': isLocationScreensGreyedOut}" alt="Location" title="Location"
                width="35" />

            <h5 class="text-center montserrat-medium "
                [ngClass]="isLocationScreensGreyedOut ? 'text-gray-light' : 'text-gray-light'">
                {{ (isLoading && highlights.locations === 0) ? '-' : (highlights.locations | number) }}
            </h5>
        </div>
        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold"
                [ngClass]="isLocationScreensGreyedOut ? 'text-gray-light' : 'text-gray-light'">Screens</span>
            <img src="./assets/images/icons/highlights/screens.svg"
                [ngClass]="{'text-gray-light': isLocationScreensGreyedOut}" width="45" alt="Screens" title="Screens"
                width="45" />
            <h5 class="text-center montserrat-medium"
                [ngClass]="isLocationScreensGreyedOut ? 'text-gray-light' : 'text-gray-light'">
                {{ (isLoading && highlights.screens === 0) ? '-' : (highlights.screens | number) }}
            </h5>
        </div>
        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Slots</span>
            <img src="./assets/images/icons/highlights/slots.svg" alt="Slots" title="Slots"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}" width="45" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && highlights.slots === 0) ? '-' : (highlights.slots | number) }}
            </h5>
        </div>
    </div>

    <div *ngIf="campaign?.billingMethod == 'PER_HOUR'" class="highlights-container bg-gray-500"
        [ngClass]="{'is-locked': isSlotPlaysGreyedOut}">
        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Plays</span>
            <img src="./assets/images/icons/dashboard/play.svg" alt="Plays" title="Plays"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}" width="35" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && highlights.plays === 0) ? '-' : (highlights.plays | number) }}
            </h5>
        </div>
    </div>

    <div *ngIf="campaign?.billingMethod == 'PER_IMPRESSION'" class="highlights-container bg-gray-500"
        [ngClass]="{'is-locked': isSlotPlaysGreyedOut}">
        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Total Impressions</span>
            <img src="./assets/images/icons/dashboard/impressions.svg" alt="Impressions" title="Impressions"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}" width="35" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && highlights.totalImpressions === 0) ? '-' : (highlights.totalImpressions | number:
                '1.0-0') }}
            </h5>
        </div>

        <!-- The provider measures plays; the local estimate measures reach. Each source shows the
             figure it actually produces rather than a blank or a borrowed one. -->
        <div *ngIf="highlights.externalMetricsSource" class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Total Plays</span>
            <img src="./assets/images/icons/dashboard/play.svg" alt="Total Plays" title="Total Plays"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}" width="35" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && highlights.plays === 0) ? '-' : (highlights.plays | number) }}
            </h5>
        </div>

        <div *ngIf="!highlights.externalMetricsSource" class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Reach</span>
            <img src="./assets/images/icons/dashboard/community.png" alt="Reach" title="Reach" [ngClass]="{
                    'text-greyed-out': isSlotPlaysGreyedOut,
                    'white-icon': !isSlotPlaysGreyedOut
                }" width="35" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && highlights.totalReaches === 0) ? '-' : (highlights.totalReaches | number) }}
            </h5>
        </div>

        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Average CPM $
            </span>

            <img src="./assets/images/icons/dashboard/cpm.png" alt="Average CPM $" title="Average CPM $" [ngClass]="{
                    'text-greyed-out': isSlotPlaysGreyedOut,
                    'white-icon': !isSlotPlaysGreyedOut
                }" width="35" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isSlotPlaysGreyedOut}">
                {{ (isLoading && (highlights.avgCPM || 0) === 0) ? '-' : (highlights.avgCPM | number)}}
                <ng-container *ngIf="isClient && !isLoading && (highlights?.avgCPM || 0) !== 0">
                    <span *ngIf="highlights.nonCappedCampaignTotalPrice != null && 
                               highlights.nonCappedCampaignTotalPrice.value != 0 &&
                               highlights.nonCappedCampaignTotalPrice.value > highlights.campaignTotalPrice?.value"
                        matTooltip="The CPM shown is indicative and may vary due to applied discounts"
                        matTooltipPosition="below" class="text-primary"
                        style="cursor: pointer; font-weight: 500">*</span>
                    <span *ngIf="highlights.nonCappedCampaignTotalPrice != null && 
                               highlights.nonCappedCampaignTotalPrice.value != 0 &&
                               highlights.nonCappedCampaignTotalPrice.value < highlights.campaignTotalPrice?.value"
                        matTooltip="Displayed CPM is indicative only; a minimum charge was applied to the campaign price"
                        matTooltipPosition="below" class="text-success"
                        style="cursor: pointer; font-weight: 500">*</span>
                </ng-container>
            </h5>
        </div>
    </div>

    <div class="highlights-container bg-gray-500" [ngClass]="{'is-locked': isBudgetPriceGreyedOut}">
        <div *ngIf="!isSupplier" class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Budget</span>
            <img src="./assets/images/icons/dashboard/dollar.svg" alt="Campaign Budget" title="Campaign Budget"
                [ngClass]="{'text-greyed-out': isBudgetPriceGreyedOut}" width="20" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isBudgetPriceGreyedOut}">
                {{
                (isLoading && highlights.campaignBudget?.value === 0) ? '-' :
                (highlights.campaignBudget?.value | currency: highlights.campaignBudget?.currencyCode)
                }}
            </h5>
        </div>

        <div class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Price</span>
            <img src="./assets/images/icons/dashboard/price-tag.svg" alt="Budget" title="Budget"
                [ngClass]="{'text-greyed-out': isBudgetPriceGreyedOut}" width="40" />
            <h5 class="text-center montserrat-medium text-gray-light"
                [ngClass]="{'text-greyed-out': isBudgetPriceGreyedOut}">
                {{
                (isLoading && (highlights?.campaignTotalPrice?.value || 0) === 0) ? '-' :
                (highlights?.campaignTotalPrice?.value || 0 | currency: highlights.campaignTotalPrice?.currencyCode)
                }}
                <ng-container *ngIf="isClient && !isLoading && (highlights?.campaignTotalPrice?.value || 0) !== 0">
                    <span *ngIf="campaign?.billingMethod == 'PER_IMPRESSION' && 
                               highlights.nonCappedCampaignTotalPrice?.value > 0 && 
                               highlights.nonCappedCampaignTotalPrice?.value < highlights.campaignTotalPrice?.value"
                        matTooltip="This price was subject to a minimum charge as per the screen supplier restrictions"
                        matTooltipPosition="below" class="text-success" style="cursor: pointer; font-weight: 500">*
                    </span>
                </ng-container>
            </h5>
            <h5 *ngIf="
                    isClient &&
                    !isBudgetPriceGreyedOut &&
                    campaign?.billingMethod == 'PER_IMPRESSION' &&
                    highlights.nonCappedCampaignTotalPrice?.value > 0 && 
                    highlights.nonCappedCampaignTotalPrice?.value > highlights.campaignTotalPrice?.value
                " class="text-center montserrat-medium" style="font-size: 16px" [ngClass]="{
                    'text-greyed-out text-strikethrough': isBudgetPriceGreyedOut,
                    'text-primary text-strikethrough': !isBudgetPriceGreyedOut
                }">
                {{
                highlights.nonCappedCampaignTotalPrice?.value | currency:
                highlights.nonCappedCampaignTotalPrice?.currencyCode
                }}
            </h5>
        </div>

        <div *ngIf="!isSupplier" class="highlight-element">
            <span class="d-block text-small montserrat-semi-bold text-gray-light">Remaining</span>
            <img src="./assets/images/icons/dashboard/budget.svg" alt="Campaign Budget" title="Campaign Budget"
                [ngClass]="{'text-greyed-out': isBudgetPriceGreyedOut}" width="40" />
            <h5 class="text-center text-white montserrat-medium" [ngClass]="{
                    'text-danger':
                        !isBudgetPriceGreyedOut &&
                        highlights.campaignBudget?.value - highlights.campaignTotalPrice?.value < 0,
                    'text-danger-greyed-out':
                        isBudgetPriceGreyedOut &&
                        this.highlights.campaignBudget?.value -
                            this.highlights.campaignTotalPrice?.value <
                            0,
                    'text-greyed-out':
                        isBudgetPriceGreyedOut &&
                        this.highlights.campaignBudget?.value -
                            this.highlights.campaignTotalPrice?.value >=
                            0
                }">
                {{
                (isLoading && highlights.campaignTotalPrice?.value === 0) ? '-' :
                (highlights.campaignBudget?.value - highlights.campaignTotalPrice?.value
                | currency: highlights.campaignBudget?.currencyCode)
                }}
            </h5>
        </div>
    </div>
</div>

<!--
    The Performance Insights drawer. It lives here because this component is the metrics dashboard
    that accompanies every step of the booking journey, and already holds the campaign the panel
    forecasts; the drawer itself is fixed to the viewport edge, so nesting it costs no layout.

    Enabled on whether the metrics call carries an external-data array at all, not on whether that
    array has anything in it. The distinction matters: on the scheduling step the client arrives
    with nothing booked, so the array is empty but the provider is still the source — and the panel
    has to be there to say what to select.

    The step decides where it appears: the panel itself shows nothing before step 3, since step 2
    has channels but no slots and so nothing to forecast.
-->
<app-performance-insights *ngIf="isClient" [campaign]="campaign" [step]="step"
    [enabled]="highlights.externalData != null">
</app-performance-insights>
